import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { Auth0Provider } from "@auth0/auth0-react";

const auth0Domain = import.meta.env.VITE_PREVISLY_AUTH0_DOMAIN || '';
const auth0ClientId = import.meta.env.VITE_PREVISLY_AUTH0_CLIENTID || '';
if(auth0Domain === "" || auth0ClientId === ""){
  console.log("missing auth0 env variables");
}

createRoot(document.getElementById("root")!).render(
  <Auth0Provider
    domain={auth0Domain}
    clientId={auth0ClientId}
    authorizationParams={{
      redirect_uri: window.location.origin
    }}
  >
    <App />
  </Auth0Provider>
);
